import React, { Component } from 'react'
import { connect } from 'react-redux'
import cn from 'classnames'
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Icon,
} from '@material-ui/core'
import { injectIntl } from 'react-intl'
import * as SLHelper from 'helpers/seaLice'
import 'styles/app/apps/seaLice/site-info.scss'
import messages from '../translate'

class SLBarrioSitesInfoTable extends Component {
  constructor(props) {
    super(props)

    this.state = {
      dataType: SLHelper.TYPE_FEMALES,
      orderWeek: this.props.activeDate.isoWeek(),
      orderDirection: false,
    }
  }

  shouldComponentUpdate(nextProps) {
    if (this.props.sitesData !== nextProps.sitesData) {
      this.setState({
        orderWeek: this.props.activeDate.week(),
        orderDirection: false,
      })

      return false
    }

    return true
  }

  getSiteData = () => {
    const data = []
    let columns = []
    const type = this.props.activeType
    const { activeBarrio } = this.props
    const sitesData = this.props.sitesData.toArray()
    const { orderWeek, orderDirection } = this.state

    for (const key in sitesData) {
      if (sitesData.hasOwnProperty(key)) {
        const row = sitesData[key]

        if (activeBarrio !== row.neighborhood_id) continue

        if (columns.length < 1) {
          columns = Array.from(row.weeks, x => x.week)
        }

        const _row = {
          id: row.site_id,
          name: row.site_name ? row.site_name : row.siep,
          weeks: {},
        }

        for (const key2 in row.weeks) {
          if (row.weeks.hasOwnProperty(key2)) {
            const week = row.weeks[key2]
            _row.weeks[week.week] = week[type]
          }
        }

        data.push(_row)
      }
    }

    data.sort((a, b) =>
      orderDirection
        ? a.weeks[orderWeek] - b.weeks[orderWeek]
        : b.weeks[orderWeek] - a.weeks[orderWeek],
    )

    return { columns, data }
  }

  onWeekOrder = e => {
    const _week = +e.currentTarget.dataset.week
    const { orderWeek, orderDirection } = this.state

    if (_week === orderWeek) {
      this.setState({ orderDirection: !orderDirection })
    } else {
      this.setState({ orderWeek: _week, orderDirection: false })
    }
  }

  render() {
    const {
      intl: { formatMessage },
      activeDate,
      activeType,
    } = this.props
    const { columns, data } = this.getSiteData()
    const activeWeek = activeDate.isoWeek()
    const { orderWeek, orderDirection } = this.state

    return (
      <div className="sealice-table">
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>{formatMessage(messages.site)}</TableCell>
              {columns.map((w, k) => (
                <TableCell
                  key={k}
                  className={cn({ activeCell: activeWeek === w })}>
                  <span
                    className={cn('weekTitle', { active: orderWeek === w })}
                    data-week={w}
                    onClick={this.onWeekOrder}>
                    W{w}{' '}
                    {orderWeek === w && (
                      <Icon>
                        {orderDirection ? 'arrow_drop_up' : 'arrow_drop_down'}
                      </Icon>
                    )}
                  </span>
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((row, i) => (
              <TableRow key={i}>
                <TableCell component="th" scope="row" data-label="Site Name">
                  {row.name}
                </TableCell>
                {columns.map((w, k) => (
                  <TableCell
                    key={k}
                    className={cn({ activeCell: activeWeek === w })}
                    data-label={`Week ${w}`}>
                    <span
                      className={`week-value ${SLHelper.getBackgroundColor(
                        row.weeks[w],
                        activeType,
                      )}`}>
                      {row.weeks[w] !== null ? row.weeks[w] : 'N/A'}
                    </span>
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    )
  }
}

export default connect(state => ({
  sitesData: state.getIn(['seaLice', 'sitesData']),
  activeDate: state.getIn(['seaLice', 'activeDate']),
  activeType: state.getIn(['seaLice', 'activeType']),
  activeBarrio: state.getIn(['seaLice', 'activeBarrios']),
}))(injectIntl(SLBarrioSitesInfoTable))
